import clsx from 'clsx';
import type { ReactElement } from 'react';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';

import './DropdownItem.scss';

interface DropdownItemProps {
  children: ReactElement;
  onClick?: () => void;
  href?: string;
  className?: string;
}

export function DropdownItem({ children, onClick, className, href }: DropdownItemProps) {
  return (
    <SDSPrimitiveButton
      className={clsx('DropdownItem', className)}
      dataTestId={DataTestIds.COMMON.DROPDOWN_ITEM}
      onClick={onClick}
      href={href}
    >
      {children}
    </SDSPrimitiveButton>
  );
}
